import React from 'react';
import { ArrowRight, Calendar } from 'lucide-react';
import profileImage from '../assets/Aikanksha.webp'; // Adjust your path here
import '../CSS/Hero.css'

const Hero = () => {
  const handleExploreServices = () => {
    document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleBookCall = () => {
    window.open('https://cal.com/akankshaa/30-min-call', '_blank');
  };

  return (
    <section className="hero relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background gradient */}
      <div className="background-gradient absolute inset-0 z-0" />

      {/* Animated dots */}
      <div className="animated-dots absolute inset-0 z-10">
        <span className="dot primary top-20 left-10 animate-pulse" />
        <span className="dot secondary top-40 right-20 animate-pulse delay-800" />
        <span className="dot accent bottom-40 left-20 animate-pulse delay-1600" />
      </div>

      {/* Content */}
      <div className="content relative z-20 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Profile Image */}
        <div className="profile-wrapper mb-8 flex justify-center">
          <div className="profile-image-container relative">
            <div className="profile-border">
              <img src={profileImage} alt="Akanksha - AI Expert" className="profile-image" />
            </div>
          </div>
        </div>

        {/* Main heading and buttons */}
        <div className="main-content space-y-6">
<h1 className="hero-heading">
  Making <span className="highlight-ai">AI </span> your growth partner
</h1>
<h2 className="hero-subheading">
  with strategy, tools, and training
</h2>

          <div className="cta-buttons flex flex-col sm:flex-row gap-4 justify-center items-center mt-12">
            <button
              onClick={handleExploreServices}
className="btn-primary group flex items-center gap-2 px-8 py-4 rounded-xl font-semibold hover:opacity-90 hover:scale-105 transition-all duration-300"
            >
              <span>Explore Services</span>
              <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-200" />
            </button>

            <button
              onClick={handleBookCall}
              className="btn-secondary group flex items-center space-x-2 px-8 py-4 rounded-xl font-semibold border border-primary hover:bg-secondary transition-all duration-300"
            >
              <Calendar size={20} />
              <span>Book a Call</span>
            </button>
          </div>

          {/* Floating badge */}
<div className="availability-badge inline-flex items-center px-4 py-2 rounded-full text-sm mt-8 glass-card">
  <span className="badge-dot" />
  Available for new projects
</div>

        </div>
      </div>

      {/* Scroll Indicator */}

    </section>
  );
};

export default Hero;
